import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

import { CompaniesResponse, CompanyState, FetchCompaniesArgs } from '../types/companyTypes';
import { getAllUserCompanies } from '../api/Installation';

const initialState: CompanyState = {
  companies: [],
  loading: false,
  error: null,
};

export const fetchCompanies = createAsyncThunk<CompaniesResponse, FetchCompaniesArgs, { rejectValue: string }>(
  'company/fetchCompanies',
  async ({ token }, { rejectWithValue }) => {
    try {
      const data = await getAllUserCompanies(token);
      return data;
    } catch (err) {
      if (err instanceof Error) {
        return rejectWithValue(err.message);
      } else {
        return rejectWithValue('An unknown error occurred');
      }
    }
  }
);
const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    resetCompanyState: (state) => {
      state.companies = initialState.companies;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanies.fulfilled, (state, action: PayloadAction<CompaniesResponse>) => {
        state.loading = false;
        state.companies = action.payload;
      })
      .addCase(fetchCompanies.rejected, (state, action: PayloadAction<string | undefined>) => {
        state.loading = false;
        state.error = action.payload || 'An unknown error occurred';
        console.error('Error in fetchCompanies:', state.error);
      });
  },
});

export const { resetCompanyState } = companySlice.actions;
export default companySlice.reducer;
